module.exports = __webpack_public_path__ + "media/images/sp/top/hairstyle_header_bg@3x-606154dcba232ea630862801990fc717.webp";